'use strict';

module.exports = function ($stateProvider) {

    $stateProvider
        .state('dashboard.departments.department.graphs', {
            url: '/graphs',
            templateUrl: 'dashboard-graphs/dashboard-graphs.html',
            controller: 'dashboardGraphsCtrl as ctrl',
            resolve: {
                graphs: ['Department', '$stateParams',  '$state', 'Authentication', function (Department, $stateParams, $state, Authentication) {
                    // console.log('llamado 7 Authentication.loadDepartments()')
                    // console.log('$state.current.name graph', $state.current)
                    return Authentication.loadDepartments().then(function(departments){
                        if (!$stateParams.departmentId && departments.length) {
                            let deptId = localStorage.getItem('lastDepartment');
                            let departmentExists = departments.find(dept => dept.id == deptId);
                            let targetDeptId = departmentExists ? deptId : departments[0].id;
                            return $state.go('dashboard.departments.department.forms', {
                                departmentId: targetDeptId
                            });
                        }
                       /*  if (Authentication.isAuthorized("viewer")) {
                           return [];
                        } else */
                            return Department.graphs({
                                id: $stateParams.departmentId                                
                            })
                                .$promise.then(function (graphs) {
                                    return graphs;
                                });
                    });
                    
                }]
            },
            data: {
                authorizedRoles: ['admin', 'mobileUser', 'viewer']
            }
        });
};